import { Buffer } from "buffer";

const processPolyfill = {
  nextTick: (callback: (...args: any[]) => void, ...args: any[]) => {
    queueMicrotask(() => {
      try {
        callback(...args);
      } catch (error) {
        setTimeout(() => {
          throw error;
        }, 0);
      }
    });
  },
  env: {},
  version: "",
  versions: {},
  browser: true,
  cwd: () => "/",
  platform: "browser",
  title: "browser",
};

if (typeof window !== "undefined") {
  (window as any).Buffer = Buffer;
  (window as any).process = processPolyfill;
  (window as any).global = window;
}

if (typeof globalThis !== "undefined") {
  (globalThis as any).Buffer = Buffer;
  (globalThis as any).process = processPolyfill;
  (globalThis as any).global = globalThis;
}

export {};
